// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      attachmentType: [
        "Business",
        "Component",
        "Document",
        "Drawing",
        "Image",
        "Link",
        "Scan",
        "Recording",
        "Technical",
        "Sound",
        "Web"
      ],
      // eslint-disable-next-line
      attachmentTheme: [
        "Audit",
        "Assessment",
        "Calculation",
        "Code",
        "Datasheet",
        "Diagram",
        "Comment",
        "Control",
        "Evaluation",
        "Layout",
        "Logic",
        "Opinion",
        "Evidence",
        "Quote",
        "Plan",
        "Review",
        "Schematic",
        "Solution",
        "Standard",
        "Task",
        "Vendor",
        "Work"
      ]
    };
  }
};
